import AsyncStorage from '@react-native-async-storage/async-storage';
import { Platform } from 'react-native';
import { Audio } from 'expo-av';

export type SoundName = 'tap' | 'success' | 'pop' | 'sign' | 'alert' | 'breakdeal';

const MUTE_KEY = 'sound_muted_v1';
const VOLUMES: Record<SoundName, number> = { tap: 0.18, success: 0.3, pop: 0.22, sign: 0.35, alert: 0.4, breakdeal: 0.5 };
const FILES: Record<SoundName, number> = {
  tap: require('../../assets/sounds/tap.wav'),
  success: require('../../assets/sounds/success.wav'),
  pop: require('../../assets/sounds/pop.wav'),
  sign: require('../../assets/sounds/sign.wav'),
  alert: require('../../assets/sounds/alert.wav'),
  breakdeal: require('../../assets/sounds/breakdeal.wav'),
};

let muted = false;
const cache: Partial<Record<SoundName, Audio.Sound>> = {};

export async function initSounds(): Promise<void> {
  if (Platform.OS === 'web') return;
  try {
    muted = (await AsyncStorage.getItem(MUTE_KEY)) === '1';
    await Audio.setAudioModeAsync({ playsInSilentModeIOS: false, shouldDuckAndroid: true });
  } catch {
    // αγνόησε
  }
}

export function isMuted(): boolean {
  return muted;
}

export async function setMuted(v: boolean): Promise<void> {
  muted = v;
  try {
    await AsyncStorage.setItem(MUTE_KEY, v ? '1' : '0');
  } catch {
    // αγνόησε
  }
}

const MAX_PLAY_MS = 3000;

export function play(name: SoundName): void {
  if (muted || Platform.OS === 'web') return;
  void (async () => {
    try {
      let s = cache[name];
      if (!s) {
        const { sound } = await Audio.Sound.createAsync(FILES[name], { volume: VOLUMES[name] });
        cache[name] = sound;
        s = sound;
      }
      await s.replayAsync();
      // Σκληρό όριο 3 δευτερολέπτων — κανένα ηχητικό εφέ δεν πρέπει να παίζει
      // πέρα από αυτό, ό,τι κι αν είναι το πραγματικό μήκος του αρχείου.
      setTimeout(() => {
        void s?.getStatusAsync().then((status) => {
          if (status.isLoaded && status.isPlaying) void s?.stopAsync();
        }).catch(() => {});
      }, MAX_PLAY_MS);
    } catch {
      // αγνόησε αποτυχίες ήχου
    }
  })();
}

export const playTap = () => play('tap');
export const playSuccess = () => play('success');
export const playPop = () => play('pop');
export const playSign = () => play('sign');
export const playAlert = () => play('alert');
export const playBreakdeal = () => play('breakdeal');
